import axios from "axios";
import { removerCaracteresEspeciais } from "@/helper/formatters";
import { makeDataSendInsp } from "@/helper/makeDataSendInsp";

class UploadInspecttion {
    async uploadInspectionPhotos(photo) {
        return new Promise(function (resolve, reject) {
            photo.image_name = removerCaracteresEspeciais(photo.image_name);
            const url = "https://uploadvist.vexsoft.com.br/api/vistoria/upload-base64";
            axios({
                method: "POST",
                url: url,
                data: photo,
                //headers: {
                //    "ngrok-skip-browser-warning": "any",
                //},
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    console.error("photo-upload-error:", err);
                    reject(err);
                });
        });
    }

    async sendInspection(data, photosObj) {
        return new Promise(function (resolve, reject) {
            data = makeDataSendInsp(data, photosObj);

            const inspectionData = {
                vist_id: data.vist_id,
                vist_json: JSON.stringify({ ...data }),
            };

            const url = "https://uploadvist.vexsoft.com.br/api/vistoria/notificarTopico";
            axios({
                method: "POST",
                url: url,
                data: inspectionData,
                //headers: {
                //    "ngrok-skip-browser-warning": "any",
                //},
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
}

export default UploadInspecttion;
